import React from 'react'
import { useSelector } from 'react-redux'
import { Spinner } from 'transfix-ui/components/Spinner'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { BackhaulIcon } from 'transfix-icons'
import { getNextStatus } from 'utils/shipmentHelpers'
import { DIALOG_UPDATE_STATUSES } from 'constants/shipments'
import {
  IN_TRANSIT_STATUSES,
  ASSIGNED_SHIPMENT_STATUS,
  TRACKING_STATUSES,
} from '../../constants/shipments'
import { OptionsTable } from '../Options'
import { ActiveShipments } from './ActiveShipments'
import { AutoAcceptRejectDetailsCard } from './AutoAcceptRejectDetails/AutoAcceptRejectDetailsCard'
import { Header } from './Header'
import { People } from './People'
import { Summary } from './Summary'
import { TenderTrackingInfo } from './TenderTrackingInfo'
import {
  SidebarNotes,
  ShipmentTracker,
  SidebarLoadDetails,
  Reloads,
  SidebarTrackingDetails,
} from './index'

export const ShipmentDetails = React.memo(() => {
  const { activeRowId, activeShipmentsCount, key, shipment, state, status } = useSelector(
    ({ shipmentsCount, sidebar }) => ({
      activeRowId: sidebar.activeRowId,
      matches: sidebar.data.matches,
      trucks: sidebar.data.trucks,
      shipment: sidebar.data.shipment,
      status: sidebar.data.shipment.status,
      key: sidebar.data.shipment.status?.key,
      state: sidebar.data.shipment.status?.state,
      activeShipmentsCount: shipmentsCount.activeShipmentsCount,
    })
  )

  const hasActiveCounts = activeShipmentsCount > 1
  const showActiveShipments =
    status && [...IN_TRANSIT_STATUSES, ...ASSIGNED_SHIPMENT_STATUS].includes(key)
  const showTracking = status && TRACKING_STATUSES.includes(key)
  const statusUpdateModal = status && state ? getNextStatus(DIALOG_UPDATE_STATUSES, state) : false
  const { getFlag } = useFeatureFlagContext()
  const { enabled: showTenderTrackingInfo } = getFlag('shipmentSidePanelTenderTrackingInfo')

  const { shipperId } = shipment?.info || {}

  return (
    <>
      <section className='sidebar-body'>
        {shipment && <Header shipment={shipment} />}
        {shipment.hasBackhaulEligibleLane && (
          <p className='flex items-start mb4'>
            <BackhaulIcon size='large' className='mr2' />
            <span>Backhaul Eligible</span>
          </p>
        )}
        {shipment && showActiveShipments && hasActiveCounts && (
          <ActiveShipments count={activeShipmentsCount} />
        )}
        {shipment && <ShipmentTracker />}
        <Reloads />
      </section>
      <hr className='mv0' />
      <section className='sidebar-body'>{shipment && <Summary shipment={shipment} />}</section>
      <hr className='mv0' />
      {showTenderTrackingInfo && shipment.id && (
        <>
          <section className='sidebar-body'>
            <TenderTrackingInfo shipmentId={shipment.id} />
          </section>
          <hr className='mv0' />
        </>
      )}
      {showTracking && <SidebarTrackingDetails showTrackingUpdateButton={!!statusUpdateModal} />}
      <section className='sidebar-body'>
        {shipment ? <People /> : <Spinner position='relative' />}
      </section>
      <hr className='mv0' />
      <section className='sidebar-body'>
        <OptionsTable activeRowId={activeRowId} />
      </section>
      <hr className='mv0' />
      <section className='sidebar-body'>
        <SidebarLoadDetails />
      </section>
      <hr className='mv0' />
      {shipperId && (
        <section className='sidebar-body'>
          <AutoAcceptRejectDetailsCard shipmentId={shipment.id} shipperId={shipperId} />
        </section>
      )}
      <hr className='mv0' />
      <section className='sidebar-body'>
        <SidebarNotes mini transparent title='Notes' notesCount={10} />
      </section>
      <hr className='mv0' />
    </>
  )
})
